function sleep(ms){return new Promise((resolve) => setTimeout(resolve, ms));}

/****************
 * pCon Camera Adjust Based on Product
 ****************/

// Name of product for pcon
var productIsStool = false;
var cameraHeight;
var cameraPitch;

// Adjust camera height and pitch if product is a stool
// if (productName.toLowerCase().includes('stool')) {
//   productIsStool = true;
//   cameraHeight = 5;
//   cameraPitch = cameraHeight * .066;
// } else {
//   productIsStool = false;
//   cameraHeight = 1.7;
//   cameraPitch = cameraHeight * .06;
// }

/****************
 * End
 ****************/

// /**
//  * @typedef ProductConfigurator
//  * @property {import("./haworth-theme").MasterProductViewModel} productData - The product data available for this PDP page
//  * @property {import("./haworth-theme").PricingData} pricingData - The pricing data for the currently logged in customer
//  * @property {number} selectedImageIndex
//  * @property {Object.<string,number>} initialPrices - The base pricing data for each tab type.
//  * @property {(url: string, width: string | number) => string} getCloudflareImageUrl
//  * @property {'ReadyToShip' | 'MadeToOrder'} selectedTab
//  * @property {import("./haworth-theme").ExtendedProductVariant?} selectedVariant
//  * @property {Object.<string,string>} selectedOptions
//  * @property {Object.<string,Object.<string,egr.wcf.eaiws.basket.Property>>} selectedPConProperties
//  * @property {pConService} pConService
//  * @property {egr.wcf.eaiws.basket.ChoiceList[]} pConChoiceLists
//  * @property {(newValue: string, choiceList: egr.wcf.eaiws.basket.ChoiceList) => Promise<void>} pconPropertySelectionChanged
//  * @property {() => void} initializeProductConfigurator
//  * @property {() => void} optionValueSelected - Called when an option value has changed to trigger updates
//  * @property {() => void} resetRenderings - Resets the renderings displayed to match the current variant
//  * @property {() => void} updateSelectionDetails - Resets pricing information for current configuration
//  * @property {(selectedTab: 'MadeToOrder' | 'ReadyToShip') => void} selectTab - Changes which tab is currently selected
//  * @property {(i: number,n: number) => number} roundToNearestOf - Rounds the first argument to the nearest iteration of the second number
//  * @property {(baseIdentifier: string, sku: string, originalPrice: number) => number} getDiscountedPrice
//  * @property {() => void} updatePConConfigurator
//  * @property {boolean} disableReadyToShip
//  * @property {boolean} variantForSelectedOptionsAvailable
//  * @property {number} currentPrice
//  * @property {number} currentCompareAtPrice
//  * @property {boolean} variantIsOnSale
//  * @property {number} selectedQuantity
//  * @property {string} selectedBaseIdentifier
//  * @property {string} selectedSku
//  * @property {() => number?} getPConCurrentPrice
//  * @property {string} pConCurrentCatalogCode
//  * @property {string} pConCurrentSupplierPartNumber
//  * @property {() => void} getRtsFormattedOptions
//  * @property {() => void} getMtoFormattedOptions
//  * @property {() => boolean} rtsOptionCanBeSelected
//  * @property {() => string} getFormattedLabelNameFromItem
//  * @property {() => string} getFormattedPconLabelNameFromItem
//  * @property {() => void} updateCarousel
//  * @property {() => void} updateAffirmMessaging
//  */

/**
 * function required for alpine.js implementation of the product configurator
 *
 * @returns {ProductConfigurator}
 */
// function productConfigurator() {
//     return {
//       /* General settings for configurator */
//       // @ts-ignore
//       productData: {},
//       selectedImageIndex: 0,
//       getCloudflareImageUrl,
//       selectedTab: 'ReadyToShip',
//       currentPrice: 0,
//       initialPrices: {
//         ReadyToShip: 0,
//         MadeToOrder: 0
//       },
//       disableReadyToShip: false,
//       variantForSelectedOptionsAvailable: true,
//       pricingDataIsLoaded: false,
//       selectedBaseIdentifier: '',
//       selectedSku: '',
//       getDiscountedPrice: window['Haworth'].getDiscountedPrice,
//       currentCompareAtPrice: 0,
//       variantIsOnSale: false,
//       selectedQuantity: 1,

//       selectTab: function (selectedTab) {
//         const configurator = /** @type {ProductConfigurator} */ (this);

//         if (!configurator.pConService.article) {
//           return;
//         }

//         configurator.selectedQuantity = 1;

//         configurator.selectedTab = selectedTab;
//         if (selectedTab === 'MadeToOrder' && configurator.productData.ConfiguratorType === 'pCon') {
//           configurator.updatePConConfigurator();
//         } else if (configurator.productData.ReadyToShipVariants.length > 0) {
//           configurator.selectedVariant = configurator.productData.ReadyToShipVariants[0];
//         }

//         configurator.updateSelectionDetails();
//         configurator.resetRenderings();
//         configurator.updateCarousel();
//       },

//       initializeProductConfigurator: function () {
//         const configurator = /** @type {ProductConfigurator} */ (this);
//         configurator.productData = window['Haworth'].productData;

//         if (configurator.productData.ReadyToShipVariants.length > 0) {
//           configurator.selectedVariant = configurator.productData.ReadyToShipVariants[0];
//         } else {
//           configurator.selectedTab = 'MadeToOrder';
//           configurator.disableReadyToShip = true;
//           if (configurator.productData.ConfiguratorType == 'ShopifyVariant' && configurator.productData.MadeToOrderProductVariants.length > 0) {
//             configurator.selectedVariant = configurator.productData.MadeToOrderProductVariants[0];
//           }
//         }

//         if (configurator.productData.ConfiguratorType == 'pCon' && configurator.productData.PconBaseArticleNumber != null) {
//           configurator.pConService = new pConService(
//             'https://ocf2.haworth.com',
//             'manual',
//             configurator.productData.PconCatalogId,
//             configurator.productData.PconCatalogPackageId,
//             configurator.productData.PconArticlePackageId,
//             configurator.productData.PconBaseArticleNumber,
//             configurator.productData.PconVariantCode
//           );
//           configurator.pConService.initialize().then(() => {
//             if (configurator.selectedTab == 'MadeToOrder') {
//               configurator.updatePConConfigurator();
//             }
          
//             if (configurator.selectedVariant != null) {
//               for (const option of configurator.selectedVariant.Options) {
//                 configurator.selectedOptions[option.OptionId] = option.Value;
//               }
//             }
          
//             configurator.updateAffirmMessaging();
//             configurator.updateCarousel();
//             configurator.updateSelectionDetails();
//             configurator.resetRenderings();
//           });
//         }

//         if (configurator.selectedVariant != null) {
//           for (const option of configurator.selectedVariant.Options) {
//             configurator.selectedOptions[option.OptionId] = option.Value;
//           }
//           configurator.updateCarousel();
//         }
      
//         configurator.updateSelectionDetails();
//         configurator.resetRenderings();
//       },

//       updateSelectionDetails: function () {
//         const configurator = /** @type {ProductConfigurator} */ (this);
//         let basePrice;

//         if (configurator.selectedTab === 'ReadyToShip' || (configurator.selectedTab === 'MadeToOrder' && configurator.productData.ConfiguratorType === 'ShopifyVariant')) {
//           configurator.selectedBaseIdentifier = configurator.selectedVariant.MaterialNumber;
//           configurator.selectedSku = configurator.selectedVariant.CatalogCode;
//           configurator.currentPrice = configurator.getDiscountedPrice(configurator.selectedBaseIdentifier, configurator.selectedSku, configurator.selectedVariant.Price);
//           configurator.currentCompareAtPrice = configurator.selectedVariant.Price;
//           configurator.productData.ReadyToShipVariants.forEach(val => {
//             if(basePrice == null || basePrice > val.Price && val.Price > 0) {
//               basePrice = configurator.getDiscountedPrice(val.MaterialNumber, val.CatalogCode, val.Price);
//             }
//           })
//         } else {
//           configurator.selectedBaseIdentifier = configurator.pConCurrentSupplierPartNumber;
//           configurator.selectedSku = 'MadeToOrder';
//           configurator.currentPrice = configurator.getDiscountedPrice(configurator.selectedBaseIdentifier, configurator.selectedSku, configurator.pConService.price);
//           configurator.currentCompareAtPrice = configurator.pConService.basePrice;
//           basePrice = configurator.getDiscountedPrice(configurator.selectedBaseIdentifier, configurator.selectedSku, configurator.pConService.basePrice);
//         }
      
//         configurator.variantIsOnSale = configurator.currentCompareAtPrice > configurator.currentPrice;
//         configurator.initialPrices[configurator.selectedTab] = basePrice || configurator.initialPrices[configurator.selectedTab]

//         configurator.updateAffirmMessaging();
//       },

//       /* Ready To Ship Variant Tab */
//       selectedVariant: null,
//       selectedOptions: {},
//       optionValueSelected: function () {
      
//         const configurator = /** @type {ProductConfigurator} */ (this);
//         const variants = configurator.productData.ReadyToShipVariants;
//         configurator.selectedVariant = variants.find((v) => v.Options.every((o) => configurator.selectedOptions[o.OptionId] == o.Value));
      
//         if (configurator.selectedVariant == null) {
//           configurator.variantForSelectedOptionsAvailable = false;
//         } else {
//           configurator.variantForSelectedOptionsAvailable = true;
//           configurator.updateSelectionDetails();
//           configurator.resetRenderings();
//         }
      
//         configurator.updateCarousel();
//       },

//       resetRenderings: function () {
//         const configurator = /** @type {ProductConfigurator} */ (this);
//         configurator.productData.GalleryMedia = configurator.productData.GalleryMedia.filter(element => element.Type != 'ProductRendering')
//         if (configurator.selectedVariant == null) {
//           return;
//         }
//         const newMedia = [...configurator.productData.GalleryMedia].filter((m) => m.Type != 'ProductRendering');
//         newMedia.unshift(
//           { Type: 'ProductRendering', Url: configurator.selectedVariant.Rendering1, AltText: 'An image of the product' },
//           { Type: 'ProductRendering', Url: configurator.selectedVariant.Rendering2, AltText: 'An image of the product' },
//           { Type: 'ProductRendering', Url: configurator.selectedVariant.Rendering3, AltText: 'An image of the product' }
//         );
//         configurator.productData.GalleryMedia = newMedia.filter((m) => m.Url != null && m.Url.length > 0);
//       },

//       /* Made To Order Variant Tab */
//       pConService: null,
//       pConCurrentCatalogCode: null,
//       pConCurrentSupplierPartNumber: null,
//       selectedPConProperties: {},
//       pConChoiceLists: [],

//       getRtsFormattedOptions: function() {
//         const configurator = /** @type {ProductConfigurator} */ (this);

//         if(!configurator.selectedVariant) return [];

//         return configurator.selectedVariant.Options.map((selectedVariantOption) => {
//           let foundElement = configurator.productData.ReadyToShipVariantOptions.find(optionValue => optionValue.Id == selectedVariantOption.OptionId)
//           return {name: foundElement.Name, value: configurator.selectedOptions[selectedVariantOption.OptionId]}
//         })
//       },

//       getMtoFormattedOptions: function() {
//         const configurator = /** @type {ProductConfigurator} */ (this);

//         let foundOptions = [];
//         Object.keys(configurator.selectedPConProperties).forEach(optionTypeKey => {
//           Object.keys(configurator.selectedPConProperties[optionTypeKey]).forEach(optionKey => {
//             let foundOption = configurator.selectedPConProperties[optionTypeKey][optionKey];
//             let visible = (foundOption.propClass != 'hidden' && !['OI_NONE_PROPCLASS','hidden'].includes(optionTypeKey) && foundOption.visible);
          
//             if (configurator.pConChoiceLists.filter(c => c.propName == foundOption.propName).length > 0){
//               foundOptions.push({
//                 name: foundOption.propText,
//                 value: foundOption.value.text,
//                 visible: visible
//               });
//             }

//           });
//         });

//         return foundOptions;
//       },

//       pconPropertySelectionChanged: async function (/** @type {string}*/ newValue, /** @type {egr.wcf.eaiws.basket.ChoiceList}*/ choiceList) {
//         const configurator = /** @type {ProductConfigurator} */ (this);

//         await configurator.pConService.setChoice(choiceList.propClass, choiceList.propName, newValue);
//         configurator.updatePConConfigurator();
//         configurator.updateCarousel();
//       },

//       updatePConConfigurator: function () {
//         const configurator = /** @type {ProductConfigurator} */ (this);
//         for (const prop of configurator.pConService.article.properties) {
//           configurator.selectedPConProperties[prop.propClass] = configurator.selectedPConProperties[prop.propClass] || {};
//           configurator.selectedPConProperties[prop.propClass][prop.propName] = prop;
//         }

//         configurator.pConChoiceLists.length = 0;

//         let choices = [];

//         configurator.pConService.article.properties.forEach(property => {
//           if (property.visible && property.choiceList){
//             let choice = configurator.pConService.choices.filter(element => element.propName == property.propName);

//             if (choice[0] !== undefined){
//               choices.push(choice[0]);
//             }
//             else {
//               let noChoice = new Object();
//               noChoice['propClass'] = property.propClass;
//               noChoice['propName'] = property.propName;
//               let values = [];
//               values[0] = property.value;
//               noChoice['values'] = values;
//               choices.push(noChoice);

//             }
//           }
//         });
      
//         configurator.pConChoiceLists = choices;
      
//         configurator.pConCurrentCatalogCode = configurator.pConService.article.getPropertyValue('hidden', 'LynxCatalogCode').value;
//         // Some configurable products have pcon option values with underscores rather than dashes.
//         // catCodeWithDashes exists only for identifying exact matches while accounting for this.
//         const catCodeWithDashes = configurator.pConService.article.getPropertyValue('hidden', 'LynxCatalogCode').value.replace(/_/g, '-');
//         configurator.pConCurrentSupplierPartNumber = configurator.pConService.article.getPropertyValue('hidden', 'SUPPLIER__PART__NUMBER').value.replace(/^_*/, '');
//         configurator.selectedVariant = configurator.productData.MadeToOrderProductVariants.find((v) => v.CatalogCode === catCodeWithDashes);
//         configurator.updateSelectionDetails();
//         configurator.resetRenderings();
//       },

//       rtsOptionCanBeSelected: function(optionToTest) {
//         const configurator = /** @type {ProductConfigurator} */ (this);

//         let simulatedOptions = Object.assign({}, configurator.selectedOptions);

//         simulatedOptions[optionToTest.OptionId] = optionToTest.Value;

//         return configurator.productData.ReadyToShipVariants.some(
//           product => product.Options.every(option => simulatedOptions[option.OptionId] == option.Value)
//         );
//       },

//       updateAffirmMessaging: function() {
//         const configurator = /** @type {ProductConfigurator} */ (this);

//         const variantChangeEvent = new CustomEvent('configuratorVariant:changed',
//           {detail: {variant: {price: configurator.currentPrice * configurator.selectedQuantity * 100}}}
//         );

//         document.dispatchEvent(variantChangeEvent);
//       },

//       changeQuantity: function (event) {
//         const configurator = /** @type {ProductConfigurator} */ (this);

//         let newQuantity = parseInt(event.target.value);

//         if (Number.isNaN(newQuantity) || newQuantity < 1) {
//           return;
//         }

//         configurator.selectedQuantity = newQuantity;

//         configurator.updateAffirmMessaging();
//         configurator.updateCarousel();
//       },

//       increaseQuantity: function() {
//         const configurator = /** @type {ProductConfigurator} */ (this);

//         configurator.selectedQuantity++;

//         configurator.updateAffirmMessaging();
//         configurator.updateCarousel();
//       },

//       decreaseQuantity: function() {
//         const configurator = /** @type {ProductConfigurator} */ (this);
//         if(configurator.selectedQuantity < 2) return;

//         configurator.selectedQuantity--;

//         configurator.updateAffirmMessaging();
//         configurator.updateCarousel();
//       },

//       updateCarousel: function() {
//         var event = new CustomEvent('option-selected', {
//           "detail": {
//             "scrollPos": window.pageYOffset
//           }
//         });
//         document.querySelector('.productConfiguratorComponent').dispatchEvent(event);
//       },

//       /* Utility functions */
//       roundToNearestOf: function (i, n) {
//         return i % n > n / 2 ? i + n - (i % n) : i - (i % n);
//       },
    
//       getFormattedLabelNameFromItem: function (item) {
//         const configurator = /** @type {ProductConfigurator} */ (this);

//         let finalLabelName = item.Name + ': ';
//         if(item.Name == 'Color') {
//           finalLabelName += configurator.selectedOptions[item.Id];
//         }
//         return finalLabelName;
//       },

//       getFormattedPconLabelNameFromItem: function (item) {
//         const configurator = /** @type {ProductConfigurator} */ (this);

//         const labelTItle = configurator.selectedPConProperties[item.propClass][item.propName].propText;
//         const selectedOption = configurator.selectedPConProperties[item.propClass][item.propName].value.text.split(' (').shift();
//         let finalLabelName = labelTItle + ': ';
//         if(item.propClass == 'color') finalLabelName += selectedOption
//         return finalLabelName;
//       },

//       formatPrice: function (priceToFormat) {
//         let priceFormatted = (typeof priceToFormat === 'undefined') ? priceToFormat : priceToFormat.toFixed(2)
//         if(isNaN(priceFormatted)) return;
//         return '$' + priceFormatted;
//       }
//     };
// }

class pConService {
  /**
   *Creates an instance of pConService.
    * @param {string} pconServerUrl
    * @param {string} startUp
    * @param {string} catalogId
    * @param {string} catalogPackageId
    * @param {string} articlePackageId
    * @param {string} baseArticleNumber
    * @param {string} variantCode
    * @param {string} productSize
    * @param {string} cameraPitch
    * @param {string} cameraHeight
    * @param {boolean} removeOtherItems - Indicates whether or not other items should be removed from the pcon session
    * @memberof pConService
    */
  constructor(pconServerUrl, startUp, catalogId, catalogPackageId, articlePackageId, baseArticleNumber, variantCode, productSize, cameraPitch, cameraHeight, removeOtherItems = false) {
    this.pconServerUrl = pconServerUrl;
    this.startUp = startUp;
    this.catalogId = catalogId;
    this.catalogPackageId = catalogPackageId;
    this.articlePackageId = articlePackageId;
    this.baseArticleNumber = baseArticleNumber;
    this.variantCode = variantCode;
    this.productSize = productSize;
    this.cameraPitch = cameraPitch;
    this.cameraHeight = cameraHeight;
    this.removeOtherItems = removeOtherItems;
  }

  /**
   * Indicates that the service has already been initialized
   *
   * @memberof pConService
   */
  //initialized = false;

  async initialize() {
    this.sessionInitializing = true;
    /** @type {egr.wcf.eaiws.EaiwsSession} */
    this.mSession = new egr.wcf.eaiws.EaiwsSession();

    const pconServerHostname = new URL(this.pconServerUrl).hostname;
    let pConSessionId = null;
    if (window.localStorage && window.localStorage.getItem('pConSession-' + pconServerHostname) != null) {
      pConSessionId = window.localStorage.getItem('pConSession-' + pconServerHostname);
    }

    if (pConSessionId == null || this.mSession.connect(this.pconServerUrl, pConSessionId) == false) {
      // Lets start a new pCon session
      await this.mSession.open(this.pconServerUrl, { startup: this.startUp });
      if (window.localStorage) {
        window.localStorage.setItem('pConSession-' + pconServerHostname, this.mSession.sessionId);
      }
    } else {
      try {
        // We're going to re-use a pCon server session, so let's make sure we're cleaned up from previous runs
        const itemIds = (await this.mSession.basket.getAllItems()).map((i) => i.itemId);
        if (this.removeOtherItems) {
          await this.mSession.basket.deleteItems(itemIds);
        }
      } catch (e) {
        // Lets start a new pCon session
        await this.mSession.open(this.pconServerUrl, { startup: this.startUp });
        if (window.localStorage) {
          window.localStorage.setItem('pConSession-' + pconServerHostname, this.mSession.sessionId);
        }
      }
    }

    this.sessionHeartbeat = setInterval(async () => {
      const tIsAlive = await this.mSession.session.keepAlive();
      if (!tIsAlive) {
        await this.mSession.open(this.pconServerUrl, { startup: this.startUp });
      }
    }, 30000);

    this.mSession.catalog.requestTimeout = 60000;
    this.mSession.basket.requestTimeout = 60000;

    // Set corresponding services for easier use;
    this.basket = this.mSession.basket;
    this.itemId = await this.basket.insertOFMLArticle(null, null, {
      baseArticleNumber: this.baseArticleNumber,
      articlePackageId: this.articlePackageId,
      catalogId: this.catalogId,
      catalogPackageId: this.catalogPackageId,
      ofmlVariantCode: this.variantCode,
    });
    // this.emptyOptionsItemId = await this.basket.insertOFMLArticle(null, null, {
    //   baseArticleNumber: this.baseArticleNumber,
    //   articlePackageId: this.articlePackageId,
    //   catalogId: this.catalogId,
    //   catalogPackageId: this.catalogPackageId
    // });
    this.article = await this.basket.getArticleData(this.itemId);
    //this.emptyOptionsArticle = await this.basket.getArticleData(this.emptyOptionsItemId);
    this.choices = await this.basket.getAllChoiceLists(this.itemId);
    // this.price = this.article.pdSalesPrice;
    // this.basePrice = this.emptyOptionsArticle.pdSalesPrice;

    this.sessionInitializing = false;
  }

  /**
   * Initializes the viewer UI for viewing the 3D element
   *
   * @returns {Promise<void>}
   * @memberof pConServiceController
   */
    async initViewer(
    viewerElement, // HTMLDivElement
    forceUpdate = false // boolean = false
  ) { // returns Promise<void> 
    // if (
    //   this.mHtmlContainer &&
    //   this.mHtmlContainer.id === viewerElement.id &&
    //   forceUpdate === false
    // ) {
    //   await this.ensureSessionInitialized();
    //   await this.ensureViewInitialized();
    //   return;
    // }
    // if (this.mHtmlContainer != null && this.mHtmlContainer != viewerElement) {
    //   await this.ensureViewInitialized();
    //   this.mCoreApp.dispose();
    //   this.mHtmlContainer.innerHTML =
    //     'A second preview was opened. Only one is allowed on a page at a time.';
    // }

    // if (this.mHtmlContainer == null) {
    //   this.mHtmlContainer = viewerElement;
    // }

    // // Ensure any other view initialization methods have finished
    // await this.ensureViewInitialized();
    try {
      this.viewInitializing = true;
      this.mHtmlContainer = viewerElement;
      await this.ensureSessionInitialized();

      const viewerOptions = new egr.wcf.core.AppInitOptions();

      // viewerOptions.adaptToDeviceRatio = true;
      // const appleOs = ['macOS', 'iPhone', 'iPad'];
      // let osAgent = navigator;
      // if (appleOs.includes(osAgent)) {
      //   viewerOptions.disableWebGL2Support = false;
      // } else {
      //   viewerOptions.disableWebGL2Support = true;
      // }
      if (this.mCoreApp == null) {
        this.mCoreApp = new egr.wcf.core.Application();
      }
      this.mCoreApp.dataPath = `https://cdn.haworth.com/haworth-configurator/data/`;
      // this.mHtmlContainer.innerHTML = '';
      this.mCoreApp.initialize(this.mHtmlContainer, viewerOptions);
      // this.mCoreApp.i18n.setLengthUnit(egr.wcf.utils.number.LengthUnit.Inch);

      // create view
      // const tView = new egr.wcf.core.view.View(
      //   this.mCoreApp.viewer,
      //   new BABYLON.Viewport(0, 0, 1, 1)
      // );

      // // Set Camera height and angle based on size
      // if (this.productSize === 'Small') {
      //   this.cameraHeight = 1;
      //   this.cameraPitch = this.cameraHeight * .07;
      // } else if (this.productSize === 'Medium' || '' || 'undefined') {
      //   this.cameraHeight = 1.7;
      //   this.cameraPitch = this.cameraHeight * .066;
      // } else {
      //   this.cameraHeight = 5;
      //   this.cameraPitch = this.cameraHeight * .06;
      // }

      // // Set background color to transparent
      // tView.viewer.backgroundColor = new BABYLON.Color4(1, 1, 1, 1.0);

      // // Set default canvas scene and navigation behavior
      // tView.cameraControl.pitchMax = this.cameraPitch;
      // tView.cameraControl.pitchMin = this.cameraPitch;
      // tView.cameraControl.panningEnabled = !1;
      // tView.cameraControl.setPosition(new BABYLON.Vector3(-10, this.cameraHeight, -10));
      // tView.cameraControl.setFixedTarget(new BABYLON.Vector3(0, 0, 0));
      // tView.cameraControl.setNavigationArea(100); // value was set based on HW models - Controls the maximum zoom out level
      // this.mCoreApp.viewer.addView(tView);
      // this.mCoreApp.scene.cameras[0].maxZ = 500; // 10k - value was set based on HW models
      // if (navigator.userAgent.indexOf('Mac OS X') != -1) { // Apple devices render clipping artifacts if minZ is too low
      //   this.mCoreApp.scene.cameras[0].minZ = 10; // Apple
      // } else {
      //   this.mCoreApp.scene.cameras[0].minZ = 1; // Windows
      // }
      // this.mCoreApp.scene.cameras[0].fov = 0.4;

      // the article manager handles now our articles
      this.mArticleManager = new egr.wcf.cf.ArticleManager(
        this.mCoreApp,
        this.mSession
      );
      this.mArticleManager.setGfjBasketIdsEnabled(true);

      // add user interaction with the articles in the 3d view
      // const defaultTool = new egr.wcf.core.tool.SelectionDefault(
      //   this.mCoreApp
      // );
      // defaultTool.deselectionEnabled = false;
      // defaultTool.showMainElementSelection = false;
      // defaultTool.showElementInteractors = true;
      // this.mCoreApp.tools.defaultTool = defaultTool;
      // this.mCoreApp.tools.startDefaultTool();

      // this.mCoreApp.viewer.resize();
      this.viewInitializing = false;
    } catch (e) {
      this.viewInitializing = false;
      throw e;
    }
  }

  /**
   * Insert a product into the viewer
   */
    async updateProductPreview(
    catalogId, // string
    catalogPackageId, // string,
    articlePackageId, // string,
    baseArticleNumber, // string,
    variantCode, // string,
    forceUpdate = false // boolean = false
  ) { // Promise<void> 

    try {
      this.viewUpdating = true;
      this.catalogId = catalogId;
      this.catalogPackageId = catalogPackageId;
      this.baseArticleNumber = baseArticleNumber;
      this.articlePackageId = articlePackageId;
      this.variantCode = variantCode;
      await this.ensureSessionInitialized();
      //await this.ensureViewInitialized();

      const basketId = await this.basket.insertOFMLArticle('', '', {
        catalogId: catalogId,
        catalogPackageId: catalogPackageId,
        articlePackageId: articlePackageId,
        baseArticleNumber: baseArticleNumber,
        variantCode: variantCode,
      });

      // for (const listener of this.mCoreApp.model.eventSelectionChanged[
      //   'mListeners'
      // ]) {
      //   this.mCoreApp.model.eventSelectionChanged.removeListener(
      //     listener
      //   );
      // }
      const article = await this.mArticleManager.createArticleById(basketId);
      // if (this.mCoreApp.model.elements.length > 0) {
      //   // remove previous inserted elements (because this example is just for single article configuration)
      //   for (const element of this.mCoreApp.model.elements) {
      //     this.mCoreApp.model.removeElement(element, true, true);
      //   }
      //   await this.mArticleManager.synchronizeSession(false); // we need to tell the server, that we deleted an item
      // }

      // // ****************** //
      // // Start of primary Aaron Edits //
      // // ****************** //

      // // Load meshes into mesh array
      // let sceneMeshesArr = [];
      // this.mCoreApp.scene.meshes.forEach((mesh) => {
      //     sceneMeshesArr.push(mesh);
      // });

      // // Create ground object
      // this.ground = BABYLON.Mesh.CreatePlane('Ground', 300, this.mCoreApp.scene);
      // this.ground.rotation.x = BABYLON.Tools.ToRadians(90);
      // this.ground.position.y = 0;
      // this.ground.receiveShadows = true;

      // // Materials
      // let groundMaterial = new BABYLON.StandardMaterial('groundMaterial', this.mCoreApp.scene);
      // groundMaterial.diffuseColor = new BABYLON.Color3(1, 1, 1);
      // groundMaterial.specularColor = new BABYLON.Color3(0, 0, 0);
      // this.ground.material = groundMaterial;

      // // Lights
      // // This first light is for shadow map and 'shadow only' hack
      // this.light = new BABYLON.DirectionalLight('light', new BABYLON.Vector3(0, -1, 0), this.mCoreApp.scene);
      // this.light.diffuse = new BABYLON.Color3(1, 1, 1);
      // this.light.specular = new BABYLON.Color3(1, 1, 1);
      // // OG value below was 100
      // this.light.position = new BABYLON.Vector3(0, 3, 0);
      // this.light.intensity = 1;
      // // Key light
      // let light2 = new BABYLON.DirectionalLight('light2', new BABYLON.Vector3(-1, -1, 0), this.mCoreApp.scene);
      // light2.intensity = 1;
      // this.light.includedOnlyMeshes.push(this.ground);
      // light2.excludedMeshes.push(this.ground);
      // light2.radius = 0.5;
      // // Fill light 1
      // let light3 = new BABYLON.DirectionalLight('light3', new BABYLON.Vector3(1, 0, 0), this.mCoreApp.scene);
      // light3.intensity = 0.5;
      // light3.position = new BABYLON.Vector3(-50, 10, 0);

      // // Shadow Generator
      // this.shadowGenerator = new BABYLON.ShadowGenerator(1024, this.light);
      // this.shadowGenerator.setDarkness(0.7);
      // this.shadowGenerator.bias = -0.05;
      // this.shadowGenerator.setTransparencyShadow(true);
      // this.shadowGenerator.useBlurExponentialShadowMap = true;
      // this.shadowGenerator.useKernelBlur = true;
      // this.shadowGenerator.blurKernel = 128;

      // // Load meshes from array into shadow map
      // sceneMeshesArr.forEach((mesh) => {
      //     this.shadowGenerator.getShadowMap().renderList.push(mesh);
      // });

      // // ****************** //
      // // End of Aaron Edits //
      // // ****************** //

      this.mCoreApp.model.addElement(article);
      this.mCoreApp.model.setSelection([article]);
      // this.resetCamera();

      // this.updateShadowsAndGround();

      this.viewUpdating = false;

    } catch (e) {
      this.viewUpdating = false;
      throw e;
    }
  }

  // async updateShadowsAndGround(){
  //       // Load all pCon Meshes into Array but exclude ground or shadows won't display properly
  //       let sceneMeshesArr = [];
  //       this.mCoreApp.scene.meshes.forEach((mesh) => {
  //           if (mesh.id != 'Ground') {
  //               sceneMeshesArr.push(mesh);
  //           }
  //       });
    
  //       // Re-load meshes on characteristic change into Shadow Generator
  //       sceneMeshesArr.forEach((mesh) => {
  //           this.shadowGenerator.getShadowMap().renderList.push(mesh);
  //       });
  // }

    /**
   * Adjusts the zoom in the viewer to fit the element being configured
   *
   */
  // resetCamera() {
  //   this.mCoreApp.viewer.activeView.cameraControl.pitchMax = this.cameraPitch;
  //   this.mCoreApp.viewer.activeView.cameraControl.pitchMin = this.cameraPitch;
  //   this.mCoreApp.viewer.activeView.cameraControl.setPosition(new BABYLON.Vector3(-10, this.cameraHeight, -10), true);
  //   this.mCoreApp.viewer.activeView.cameraControl.setNavigationArea(50); // value was set based on HW models
  //   this.mCoreApp.viewer.activeView.cameraControl.setFixedTarget(new BABYLON.Vector3(0, 0, 0));
  //   this.mCoreApp.viewer.activeView.cameraControl.zoomToFitElements(null, {margin: 0.15,});
  // }

  // base64ToBlobDownload(content, filename){
  //     let blob;
  //     const imageData = atob(content.split(',')[1]);
  //     const arrayBuffer = new ArrayBuffer(imageData.length);
  //     const view = new Uint8Array(arrayBuffer);
  //     for (let i = 0; i < imageData.length; i++) {
  //         view[i] = imageData.charCodeAt(i) & 0xff;
  //     }
  
  //     blob = new Blob([arrayBuffer], { type: 'image/png' });
  //     saveAs(blob, filename);
  // };
  
    /**
     * Take current view of the configurator and generate a base64 image string
     * pass to utility method base64toBlobDownload to create a new image download
     *
     */
    // async saveScreenshot() {
    //   // determine if the product is wider than it is tall and change the screenshot output based on that.
    //   // Cut sheet available space is a narrow aspect ratio and products that fit in the space should fill the space
    //   // Products that are wider than cut sheet available space will use default screenshot rendering
    //   // to fit the product within cut sheet available space.
  
    //   const image = await this.captureViewerScreenShot({ width: 2000, height: 2000 });

    //     let catalogCode = this.article.properties.filter(p => p.propName == "LynxCatalogCode")[0].value.value;
    //     let filename = "download";
    //     if (catalogCode) {
    //       filename = "VARIANT-" + catalogCode;
    //     }
    //     this.base64ToBlobDownload(image, `${filename}.png`);
    // }
  
    // /**
    //  * Captures a screenshot from the pCon viewer
    //  *
    //  * @param [options]
    //  * @returns
    //  */
    // async captureViewerScreenShot(options) {
    //     const screenshotOptions = options || {
    //         width: this.mCoreApp.viewer.width,
    //         height: this.mCoreApp.viewer.height
    //     };
    //     return await this.mCoreApp.viewer.createScreenshot(this.mCoreApp.viewer.activeView, screenshotOptions);
    // }

//  async ensureViewUpdated() {
//     while (this.viewUpdating) {
//       await sleep(100);
//     }
//   }

    /**
   * Since this service is shared between all components on a page the same method (i.e. initialization) might be called multiple times
   * with the same details. We should generally be waiting for any other methods to complete their execution before continuing. This mehtod
   *
   *
   * @private
   * @memberof PconServiceController
   */
    async ensureSessionInitialized() {
      while (this.sessionInitializing) {
        await sleep(100);
      }
    }

    /**
     * Since this service is shared between all components on a page the same method (i.e. initialization) might be called multiple times
     * with the same details. We should generally be waiting for any other methods to complete their execution before continuing. This mehtod
     *
     *
     * @private
     * @memberof PconServiceController
     */
    // async ensureViewInitialized() {
    //   while (this.viewInitializing) {
    //     await sleep(100);
    //   }
    // }

  /**
   * Given a choicelist and a value this will select the given value and update
   * the article information, choices list, and price to reflect the new selection.
   *
   * @param {egr.wcf.eaiws.basket.ChoiceList} choiceList
   * @param {string} value
   * @memberof pConService
   */
  async setChoice(propClass, propName, value) {
    await this.basket.setPropertyValue(this.itemId, propClass, propName, value);
    this.article = await this.basket.getArticleData(this.itemId);
    this.choices = await this.basket.getAllChoiceLists(this.itemId);
    this.price = this.article.pdSalesPrice;
  }
}